import { call, put, select } from "redux-saga/effects";
import cirrusClient from "../../../services/api/cirrus-client";
import { setAllowedAudioCodecs, setRemovedAudioCodecs } from "../../../state/config/configSlice";

export function* fetchPortalConfigSaga() {
    try {

        const apiUrl = '?object=uiconfig&action=read';
        // Parameters for the API call
        const params = {
            config_name: 'PORTAL_*',
            format: 'json',
            domain: '*',
            user: '*',
            hostname: 'cirrus.blinkcomet.com',
            role: '*',
            reseller: '*'

        };
        const response = yield call(cirrusClient.get, apiUrl, { params });
        const configs = response.data;

        const codecListConfig = configs.find(c => c.config_name === 'PORTAL_WEBRTC_CODEC_LIST_AUDIO');
        const codecRemovedConfig = configs.find(c => c.config_name === 'PORTAL_WEBRTC_CODEC_REMOVED_AUDIO');

        if (codecListConfig && codecListConfig.config_value) {
            yield put(setAllowedAudioCodecs(codecListConfig.config_value));
            console.log('[VERBOSE] Allowed audio codecs:', codecListConfig.config_value);
        }

        if (codecRemovedConfig && codecRemovedConfig.config_value) {
            yield put(setRemovedAudioCodecs(codecRemovedConfig.config_value));
            console.log('[VERBOSE] Removed audio codecs:', codecRemovedConfig.config_value);
        } else {
            // Default to removing G726 and G729 if not configured
            yield put(setRemovedAudioCodecs('2 18'));
            console.log('Using default removed codecs: 2 18');
        }

    } catch (error) {
        console.error('Error fetching portal config', error)
    }
} 